export default __webpack_public_path__ + "static/media/tuspark@2x.cede2489.png";